import styled from "styled-components";

const DefaultMark = styled.span`
	align-self: flex-end;
	opacity: 0.5;
`;

export default DefaultMark;
